import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  IonList,
  IonItem,
  IonLabel,
  IonRefresher,
  IonRefresherContent,
} from '@ionic/react';
import { useHistory } from 'react-router-dom';
import { PageLayout } from 'containers/layout';
import { VenueLogo } from 'components/venue';
import { AuthSelectors } from 'redux/AuthRedux';
import PromotionActions, { PromotionSelectors } from 'redux/PromotionRedux';
import api_v2 from 'services/api_v2';

function PromotionsPage() {
  const token = useSelector(AuthSelectors.selectToken);
  const venues = useSelector(PromotionSelectors.selectPromotionVenues);
  const history = useHistory();
  const dispatch = useDispatch();
  
  const handleLoadPromotions = async (e) => {
    try {
      const api = api_v2(token);

      const resp = await api.getPromotions({});
      if (resp) {
        dispatch(PromotionActions.setPromotions(resp));
      }
    } catch (err) {
      console.log('get promotions error: ', err);
    }

    e.detail.complete();
  };

  return (
    <PageLayout title="Promotions">
      <IonRefresher slot="fixed" onIonRefresh={handleLoadPromotions}>
        <IonRefresherContent />
      </IonRefresher>
      <IonList>
        {venues.map((loc) => (
          <IonItem
            key={loc.id}
            button
            onClick={() => history.push(`/promotions/${loc.id}`)}
          >
            <VenueLogo logo={loc.logo} />
            <IonLabel>
              <h2>{loc.name}</h2>
              <p>{loc.address}</p>
            </IonLabel>
          </IonItem>
        ))}
      </IonList>
    </PageLayout>
  );
}

export default PromotionsPage;
